<mat-button-toggle-group class="st-cast-main-cta-button-group">
    <mat-button-toggle
        class="st-cast-main-cta-button-new-topic"
        [class.st-cast-main-cta-button-new-topic__disabled]="!topicEditable"
        [disabled]="!topicEditable"
        (click)="onNewTopicClicked()">
        <mat-icon class="material-symbols-outlined">add</mat-icon>
        {{ languageSettings.PSTObjectTypeTopic }}
    </mat-button-toggle>
    <mat-button-toggle
        mat-icon-button
        class="st-cast-main-cta-button-new-topic-template"
        [class.st-cast-main-cta-button-new-topic-template__disabled]="!topicEditable"
        [matMenuTriggerFor]="topicTemplateMenu"
        [disabled]="topicTemplatesDisabled()"
        (menuOpened)="onTopicTemplateMenuOpened()">
        <mat-icon>arrow_drop_down</mat-icon>
    </mat-button-toggle>
</mat-button-toggle-group>

<mat-menu
    #topicTemplateMenu="matMenu"
    class="st-cast-main-cta-templates-menu">
    @if (topicTemplates().length > 0) {
        <ng-template matMenuContent>
            @for (item of topicTemplates(); track item?.Guid) {
                <mat-selection-list
                    hideSingleSelectionIndicator
                    [multiple]="false">
                    <mat-list-option
                        st-click-stop-propagation
                        [value]="item?.Title"
                        (click)="selectTopicTemplate(item)">
                        <div
                            matListItemTitle
                            class="st-cast-main-cta-button-new-topic-template__title"
                            [dir]="directionality()">
                            <span>{{ item?.Title }}</span>
                            <button
                                mat-icon-button
                                matListItemMeta
                                st-click-stop-propagation
                                class="st-cast-main-cta-button-new-topic-template__delete-button"
                                (click)="deleteTemplate(item)">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </mat-list-option>
                </mat-selection-list>
            }
        </ng-template>
    }
</mat-menu>
